import { useEffect } from 'react'

import * as Sentry from '@sentry/react'

import { authService } from '@/services/auth-service'
import { localStorageService, sessionStorageService } from '@/services/storage-service'
import { useAppState } from '@/states/app-state'

export function SentryUserContext() {
  const profile = useAppState((state) => state.profile)

  useEffect(() => {
    if (!profile) return
    Sentry.setUser({
      ...profile,
      jwtGuid: authService.getJwtGuid(),
      bfp: localStorageService.getBfp(),
      sfp: sessionStorageService.getSfp(),
      'x-react-app-version': process.env.REACT_APP_VERSION,
    })
  }, [profile])

  return null
}
